import { ContentWrapper } from "@insite/content-library/Widgets/Basic/RichContent";
import { StyledButton } from "@insite/mobius/Clickable";
import { GridOffset } from "@insite/mobius/GridContainer";
import { StyledTypography } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { TypographyWrapper } from "@waytek/MobiusOverrides/Link/Link";
import { footerContainerStyles as containerStyle } from "@waytek/Overrides/Widgets/Footer/FooterContainer";
import { colorStrings, fontFamily, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

containerStyle.footerWrapper = {
    css: css`
        max-width: 1220px;
        padding: 32px 20px 50px;
        margin: auto;

        ${mediaQueriesBP.maxMD} {
            padding: 32px 20px 35px;
        }
    `,
};

containerStyle.widgetGridContainer = {
    gap: 0,
};

containerStyle.leftGridItem = {
    width: [12, 12, 4, 4, 4],
};

containerStyle.logoWrapper = {
    css: css``,
};

containerStyle.logoGridItem = {
    width: [12, 12, 9, 7, 7],
    css: css`
        width: 100%;
        display: flex;

        ${mediaQueriesBP.maxMD} {
            justify-content: flex-start;
        }
    `,
};

containerStyle.subscribeGridItem = {
    width: 12,
};

containerStyle.socialLinksGridItem = {
    width: 12,
};

const linkStyle = css`
    ${StyledButton} {
        text-decoration: none;
        border-bottom: 0;

        ${StyledTypography} {
            border-bottom: 0;
        }
    }
`;

containerStyle.rightGridItem = {
    width: [12, 12, 8, 8, 8],
    css: css`
        .link-list__widget {
            text-transform: none;

            & > div:first-child {
                ${TypographyStyle} {
                    font-family: ${fontFamily};
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                }

                ${linkStyle}
            }

            & > div:not(:first-child) {
                display: flex;

                ${linkStyle}
            }

            & > div:nth-child(2) {
                ${mediaQueriesBP.maxMD} {
                    margin-top: 20px;
                }

                ${mediaQueriesBP.minMD} {
                    margin-top: 23px;
                }
            }

            & > div:nth-child(n + 2) {
                ${mediaQueriesBP.maxMD} {
                    margin-top: 15px;
                }

                ${mediaQueriesBP.minMD} {
                    margin-top: 21px;
                }
            }
        }
    `,
};

containerStyle.linkListContainer = {
    gap: 20,
    css: css`
        ${mediaQueriesBP.minLG} {
            ${GridOffset} {
                justify-content: flex-end;
            }
        }
    `,
};

containerStyle.linkList1GridItem = {
    width: [6, 6, 6, 3, 3],
};

containerStyle.linkList2GridItem = {
    width: [6, 6, 6, 3, 3],
};

containerStyle.linkList3GridItem = {
    width: [6, 6, 6, 3, 3],
};

containerStyle.linkList4GridItem = {
    width: [6, 6, 6, 3, 3],
};

containerStyle.bottomFooter = {
    css: css`
        position: relative;
    `,
};

containerStyle.bottomFooterWrapper = {
    css: css`
        background-color: ${getColor(colorStrings.primaryMain)};
        position: relative;
        clip-path: polygon(0 0, calc(100% - 52px) 0, calc(100% - 23px) 100%, 0 100%);

        ${mediaQueriesBP.maxMD} {
            padding-top: 24px;
            padding-bottom: 22px;
            clip-path: polygon(0 0, calc(100% - 75px) 0, calc(100% - 23px) 100%, 0 100%);
        }

        .list-wrapper {
            padding: 0;

            .list-link {
                ${TypographyWrapper} {
                    color: ${getColor(colorStrings.commonGlobalWhite)};

                    &:hover > ${TypographyStyle} {
                        border-bottom-color: ${getColor(colorStrings.commonGlobalWhite)};
                    }
                }

                ${TypographyStyle} {
                    color: ${getColor(colorStrings.commonGlobalWhite)};
                }
            }

            ${mediaQueriesBP.maxMD} {
                text-align: left;
            }
        }
    `,
};

containerStyle.bottomGridContainer = {
    gap: 0,
    css: css`
        max-width: 1220px;
        padding: 13px 20px;
        margin: auto;

        ${ContentWrapper} {
            color: ${getColor(colorStrings.commonGlobalWhite)};
        }

        ${TypographyStyle} {
            color: ${getColor(colorStrings.commonGlobalWhite)};
        }

        ${mediaQueriesBP.maxMD} {
            padding: 0 20px;

            ${ContentWrapper} {
                font-size: 12px;
                line-height: 15px;
            }
        }

        ${mediaQueriesBP.minMD} {
            min-height: 50px;
        }

        @media screen and (max-width: 797px) {
            padding-right: 108px;
        }

        @media screen and (max-width: 1199px) {
            padding-right: 87px;
        }

        @media screen and (min-width: 1200px) and (max-width: 1340px) {
            padding-right: calc(20px + 52px - ((100vw - 1230px) / 2));
        }
    `,
};

containerStyle.richContentGridItem = {
    width: [12, 12, 6, 6, 6],
};

containerStyle.siteMapLinksGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        .link-list__widget {
            padding: 0;
            text-transform: none;

            & > div {
                padding: 0;

                & + div {
                    &::before {
                        content: "\00a0\00a0|\00a0\00a0";
                        color: ${getColor(colorStrings.commonGlobalWhite)};
                    }
                }
            }

            ${StyledButton} {
                display: inline-block;
            }

            ${TypographyStyle} {
                font-size: 14px;
                color: ${getColor(colorStrings.commonGlobalWhite)};
                text-decoration: underline;

                &:hover {
                    border-bottom: 1px solid ${getColor(colorStrings.commonGlobalWhite)};
                }
            }
        }

        ${mediaQueriesBP.maxMD} {
            &&& {
                margin-top: 14px;
            }

            .link-list__widget {
                text-align: left;
                line-height: 15px;

                & > div {
                    line-height: 15px;
                    height: 15px;
                }

                ${TypographyStyle} {
                    font-size: 12px;
                    line-height: 15px;
                }
            }
        }
    `,
};

containerStyle.bottomFooterDecoration = {
    css: css`
        position: absolute;
        top: 0;
        right: 0;
        width: 75px;
        height: 100%;
        background-color: ${getColor(colorStrings.commonGlobalFooterSection1)};
        clip-path: polygon(0 0, 46px 0, 100% 100%, calc(100% - 46px) 100%);

        &::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            width: 100%;
            height: 100%;
            background-color: ${getColor(colorStrings.commonGlobalFooterSection2)};
            clip-path: polygon(23px 0, 46px 0, 100% 100%, calc(100% - 23px) 100%);
        }

        ${mediaQueriesBP.maxMD} {
            width: 98px;
        }
    `,
};
